<div class="page">
  <div style="padding-right: 0;">
    <mat-sidenav-container>
      <mat-sidenav #sidenav mode="side" position="end" opened="true"
                   style="width: 350px;">

        <!--               -->
        <!-- SIDE PANEL FOR NATURAL PERSONS / LEGAL ENTITIES IN THE KYC -->
        <!--               -->
        <div class="side-panel">
          <div class="row pt-3 pb-3">
            <div class="col-12">
              <span style="font-size: small;">
                This section contains 'Natural Persons' and 'Legal Entities' either used within this KYC, or available to be used with the KYC.
                You can edit them to fill in the information required, and select them whenever <strong style="white-space: nowrap;">"Add Natural Person"</strong>, and <strong style="white-space: nowrap;">"Add Legal Entity"</strong> buttons appear.
              </span>
            </div>
          </div>
          
          <mat-card class="cache-top-container">
            <h2>Natural Person</h2>
            <div class="cache-body">
              <div>
                <em>As you add persons to your KYC and fill in their info, this list will populate and you can reuse the information block.</em>
              </div>
              <div class="cache-container" *ngIf="personsCache.length > 0">
                <div *ngFor="let element of personsCache" class="person">
                  <div style="max-width: 200px;">
                    <span
                      style="font-weight: bold;">{{ element?.firstName + ' ' + element?.lastName }}</span><br/>
                    <em style="font-size: smaller; color: blue" *ngIf="isPersonUsedOnForm(element)">Person used in KYC</em>
                    <em style="font-size: smaller; color: orange" *ngIf="!isPersonUsedOnForm(element)">Person NOT used in KYC</em>
                  </div>
                  <div>
                    <button mat-icon-button [matMenuTriggerFor]="personMenu">
                      <mat-icon [matBadge]="element?.commonErrors?.length == 0 ? null : element?.commonErrors?.length" matBadgeColor="warn"
                        [title]="element?.commonErrors?.length ? 'Contains errors or missing information' : ''">menu</mat-icon>
                    </button>
                    <mat-menu #personMenu="matMenu">
                      <button mat-menu-item (click)="editItem_Person(element.id)" *ngIf="isFormDisabled()">
                        <mat-icon [matBadge]="element?.commonErrors?.length == 0 ? null : element?.commonErrors?.length"
                          matBadgeColor="warn">visibility
                        </mat-icon>
                        <span>View Person</span>
                      </button>
                      <button mat-menu-item (click)="editItem_Person(element.id)" *ngIf="isFormDisabled() == false">
                        <mat-icon [matBadge]="element?.commonErrors?.length == 0 ? null : element?.commonErrors?.length"
                          matBadgeColor="warn">edit
                        </mat-icon>
                        <span>Edit Person</span>
                      </button>
                      <button mat-menu-item (click)="deletePerson(element)"
                              [disabled]="isFormDisabled()"
                              [ngStyle]="{'cursor': isFormDisabled()? 'not-allowed' : ''}">
                        <mat-icon>delete</mat-icon>
                        <span>Delete Person</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>
              </div>

            </div>
          </mat-card>

          <mat-card class="cache-top-container mt-2">
            <h2>
              Legal Entities
            </h2>
            <div>
              <em>As you add legal entities to your KYC and fill in their info, this list will populate and you can reuse the information block.</em>
            </div>
            <div class="cache-container" *ngIf="legalEntitiesCache.length > 0">
              <div *ngFor="let element of legalEntitiesCache" class="legal-entity">
                <div>
                  <div>
                    <span style="font-weight: bold;">{{ element?.['legalName'] }}</span><br/>
                    <em style="font-size: smaller; color: blue" *ngIf="isBusinessUsedOnForm(element)">Legal Entity used in KYC</em>
                    <em style="font-size: smaller; color: orange" *ngIf="!isBusinessUsedOnForm(element)">Legal Entity NOT used in KYC</em>
                  </div>
                </div>
                <div>
                  <button mat-icon-button [matMenuTriggerFor]="businessMenu">
                    <mat-icon [matBadge]="element?.commonErrors?.length == 0 ? null : element?.commonErrors?.length" matBadgeColor="warn"
                      [title]="element?.commonErrors?.length ? 'Contains errors or missing information' : ''">menu</mat-icon>
                  </button>
                  <mat-menu #businessMenu="matMenu">
                    <button mat-menu-item (click)="editItem_LegalEntity(element.id)" *ngIf="isFormDisabled()">
                      <mat-icon [matBadge]="element?.commonErrors?.length == 0 ? null : element?.commonErrors?.length"
                        matBadgeColor="warn">visibility
                      </mat-icon>
                      <span>View Legal Entity</span>
                    </button>
                    <button mat-menu-item (click)="editItem_LegalEntity(element.id)" *ngIf="isFormDisabled() == false">
                      <mat-icon [matBadge]="element?.commonErrors?.length == 0 ? null : element?.commonErrors?.length"
                                matBadgeColor="warn">edit
                      </mat-icon>
                      <span>Edit Legal Entity</span>
                    </button>
                    <button mat-menu-item (click)="deleteBusiness(element)"
                            [disabled]="isFormDisabled()"
                            [ngStyle]="{'cursor': isFormDisabled()? 'not-allowed' : ''}">
                      <mat-icon>delete</mat-icon>
                      <span>Delete Legal Entity</span>
                    </button>
                  </mat-menu>
                </div>
              </div>
            </div>

          </mat-card>
        </div>
      </mat-sidenav>


      <!--               -->
      <!-- CONTENT START -->
      <!--               -->
      <mat-sidenav-content style="height: calc(100vh - 240px);" class="p-3" *ngIf="!!selectedEntityKyc">
         
        <form [formGroup]="adminSettingsForm" *ngIf="util.isAdmin()" (ngSubmit)="saveAdminSettings()">
            <!-- ADMIN SECTION -->
            <div class="row pt-1">
              <div class="col-12">
                <span class="rm-title-2-5">Admin Information</span>
              </div>
            </div>
            <!-- KYC STATUS-->
            <div class="row pt-4">
              <div class="col-12">
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>KYC Status</mat-label>
                  <mat-select id="kycStatus" formControlName="kycRondeivuStatus">
                    <mat-option *ngFor="let s of lookupService.lookups.kycRondeivuStatus" [value]="s.key">{{ s.value }}</mat-option>
                  </mat-select>
                  <mat-hint align="end">A change in KYC status can send out emails to users</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-12 pt-2">
                <mat-checkbox color="primary"
                              formControlName="archived"
                              [title]="'Archiving is automated, but can be set manually using this control'"
                              titlePosition="left"
                >
                  Archive KYC<br />
                  <em class="text-muted">If a KYC is archived it is no longer in use, it will not show up or be usable in the platform</em>
                </mat-checkbox>
              </div>
            </div>
            <!-- KYC NAME-->
            <div class="row pt-4">
              <div class="col-12">
                <mat-form-field appearance="outline" class="form-field">
                  <mat-label>KYC Name</mat-label>
                  <input matInput type="text"
                         formControlName="kycName"
                         placeholder="e.g. KYC for Entity"
                         required
                  />
                  <mat-hint align="end"></mat-hint>
                </mat-form-field>
              </div>
            </div>
            <!--                -->
            <!-- COMMENTS START -->
            <!--                -->
            <div class="row pt-2">
              <div class="col-12">
                <mat-form-field class="form-field" appearance="outline" floatLabel="always">
                  <mat-label>Public Comments to User</mat-label>
                  <textarea matInput type="textarea"
                            formControlName="publicComments"
                            placeholder="Comments typed in here will always be visible to the KYC clients. Use this space to let them know about things they need to change, update, or add in order for the KYC to become acceptable to Rondeivu."
                            style="min-height: 75px;max-height: 175px;"
                  ></textarea>
                </mat-form-field>
              </div>
              <div class="col-12">
                <mat-form-field class="form-field" appearance="outline" floatLabel="always">
                  <mat-label>Private Comments for Rondeivu</mat-label>
                  <textarea matInput type="textarea"
                            formControlName="privateComments"
                            placeholder="Comments here are only seen by Rondeivu Admin. Use this as a place for private notes on this KYC."
                            style="min-height: 75px;max-height: 175px;"
                  ></textarea>
                </mat-form-field>
              </div>
            </div>
            <!-- SAVE BUTTON -->
            <div class="row" style="padding-bottom: 50px;">
              <div class="col-12 text-end">
                <button type="button" mat-raised-button color="primary"
                  (click)="saveAdminSettings()"
                  [hasPermission]="util.Permission.CAN_EDIT_KYC_ADMIN"
                >
                  Save Admin Settings
                </button>
              </div>
            </div>


            <!-- PUBLIC section  -->
            <!-- CLIENT SECTION -->
            <div class="row pt-4">
              <div class="col-12">
                <span class="rm-title-2-5">Public View</span>&nbsp;
                <em>Everything below is what will be seen by non-admin users</em>
              </div>
            </div>
            <hr/>
        </form>

        <!--                -->
        <!-- COMMENTS START -->
        <!--                -->
        <form [formGroup]="form" *ngIf="!!selectedEntityKyc">
          <!-- Rondeivu Public Comments  -->
          <div class="row pt-2 pb-2" *ngIf="selectedEntityKyc.publicComments">
            <div class="col-12">
              <div class="comment-box">
                <span class="rm-title-2">Rondeivu's Comments on this KYC</span><br/>
                {{ selectedEntityKyc.publicComments }}
              </div>
            </div>
          </div>

          <!-- HEADER TEXTS-->
          <div class="row pt-2">
            <p *ngFor="let p of selectedEntityKyc.kycHeader.headerTexts">{{p.detail}}</p>
          </div>

          <!-- Issuer QUESTIONS-->
          <div class="row pt-2" style="display: flex; flex-direction: column; gap: 10px;" [formArrayName]="FORM_HEADER_QUESTIONS">
            <div class="kyc-question" *ngFor="let q of getFormArray(FORM_HEADER_QUESTIONS).controls; let i = index;" [formGroupName]="i">
              <div style="display: flex; width: 100%; gap: 15px; justify-content: start; align-items: center">
                <mat-checkbox style="display: inline-flex;" color="primary" [disabled]="isFormDisabled()" [id]="q.value.questionAnswerAttribute"
                  (change)="kycHeaderQuestionCheckboxChanged($event)" formControlName="questionAnswer"></mat-checkbox>
                <span style="display: inline-flex;">{{q.value.questionText}}</span>
              </div>
              <hr  style="display: block; width: 100%;" *ngIf="i == 0">
            </div>
          </div>

          <div class="row pt-2">
            <p *ngFor="let p of selectedEntityKyc.kycHeader.footerTexts">{{p.detail}}</p>
          </div>

          <div class="pb-2" style="display: flex; align-items: center; gap: 8px; color: orange; font-style: italic;" *ngIf="isFormDisabled()">
            <mat-icon>warning</mat-icon>
            <span>Form inputs are disabled as KYC is already submitted!
            </span>
          </div>

          <div class="pb-2" style="display: flex; align-items: center; gap: 8px; color: orange; font-style: italic;" *ngIf="selectedEntityKyc.archived">
            <mat-icon>warning</mat-icon>
            <span>
              KYC is archived!  This form can not be edited while in Archived state!
            </span>
          </div>

          <!--               -->
          <!-- PANELS START  -->
          <!--               -->
          <div class="row pb-1">
            <mat-accordion multi="false" #mainAccordion id="mainAccordion">
              <mat-expansion-panel *ngFor="let section of selectedEntityKyc.kycSections; let i = index;" #expansionPanels [hidden]="section.hidden"
                      [id]="section.kycSectionType" (opened)="panelOpened(section.kycSectionType)">

                <mat-expansion-panel-header>
                  <mat-panel-title class="panel-header"> 
                    {{section.kycSectionTitle}}
                    <div style="display: flex; gap: 10px;">
                      <mat-icon *ngIf="getComplyAdvantageErrors(section).length > 0" title="Comply Advantage Error(s)" style="color: orange">warning_amber</mat-icon>
                      <mat-icon *ngIf="getInformationalErrors(section).length == 0" color="primary" title="Validation OK">check_circle</mat-icon>
                      <mat-icon *ngIf="getInformationalErrors(section).length > 0" color="warn" title="Contains Validation Errors">error_outline</mat-icon>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="kyc-section">
                  <div class="section-header" *ngIf="section.kycSectionHeader.headerTexts.length > 0">
                    <span *ngFor="let txt of section.kycSectionHeader.headerTexts" class="header-text">
                      <span>{{txt.detail}}</span>
                      <ul *ngIf="txt.list?.length">
                        <li *ngFor="let item of txt.list">{{item.listDetail}}</li>
                      </ul>
                    </span>
                  </div>
                  <div class="section-errors" *ngIf="section.errors != null && section.errors.length > 0">
                    <div *ngFor="let e of section.errors">
                      <span *ngIf="e.errorType == 'VALIDATION_ERROR'" style="color: #666;">{{e.errorMessage}} (click validate button to update)</span>
                      <span *ngIf="e.errorType == 'COMPLY_ERROR'" style="color: orange;">{{e.errorMessage}}</span>
                    </div>
                  </div>
                  <div class="section-questions" style="display: flex; flex-direction: column;" 
                    *ngIf="section.kycSectionHeader.kycQuestions.length > 0" [formArrayName]="FORM_QUESTIONS">
                    <div *ngFor="let question of getFormArray(FORM_QUESTIONS).controls; let i = index" [formGroupName]="i" style="display: block; margin: 0; padding: 0; ">
                      <div *ngIf="questionContainerInSection(section.kycSectionHeader.kycQuestions, question.value.questionAnswerAttribute)">

                        <!-- Radio Button  -->
                        <div class="col-12" *ngIf="question.value.questionType == 'RADIO'"
                          style="display: flex; justify-content: space-between; align-items: center; margin-top: 15px;">
                          <div class="col-8">
                            {{question.value.questionText}} 
                          </div>
                          <div class="col-2">
                            <mat-radio-group style="display: flex; gap: 12px; justify-content: end;" 
                              formControlName="questionAnswer" [disabled]="isFormDisabled()">
                              <mat-radio-button color="primary" value="true">Yes</mat-radio-button>
                              <mat-radio-button color="primary" value="false">No</mat-radio-button>
                            </mat-radio-group>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                  <!-- sections  -->
                  <div class="section-body pt-4" [ngSwitch]="section.kycSectionType">

                    <!-- ONBOARDING PEROSN  -->
                    <div *ngSwitchCase="SectionType.ONBOARDING">
                      <div class="col-12">
                        <button type="button" mat-raised-button color="primary" [disabled]="formHasAtLeastOneEntry(FORM_ONBOARDING_PEOPLE) || isFormDisabled()"
                          (click)="addPersonToForm(FORM_ONBOARDING_PEOPLE, Level.BASIC)">Add Onboarding Person</button>
                      </div>

                      <table class="mt-4 mat-elevation-z4" width="100%">
                        <thead>
                          <th class="form-table-header">Onboarding Person</th>
                          <th class="form-table-header center">Actions</th>
                        </thead>
                        <tbody [formArrayName]="FORM_ONBOARDING_PEOPLE">
                          <tr *ngFor="let p of getFormArray(FORM_ONBOARDING_PEOPLE).controls; let i = index" [formGroupName]="i" >
                            <td>
                              <kyc-person (click)="editItem_Person(p.value.id)" [person]="getPersonFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-person>
                            </td>
                            <td class="text-center">
                              <button type="button" mat-icon-button (click)="editItem_Person(p.value.id)" [disabled]="isFormDisabled()">
                                <mat-icon>edit</mat-icon>
                              </button>
                              <button type="button" mat-icon-button color="warn" [disabled]="isFormDisabled()" (click)="removeItem(FORM_ONBOARDING_PEOPLE, i)">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </td>
                          </tr>
                          <tr *ngIf="isFormCollectionEmpty(FORM_ONBOARDING_PEOPLE)">
                            <td colspan="5">No data in this table.</td>
                          </tr>    
                        </tbody>
                      </table>
                    </div>
  
                    <!-- CLIENT INFORMATION  -->
                    <div *ngSwitchCase="SectionType.ENTITY_INFORMATION">
                      <div class="col-12">
                        <button type="button" mat-raised-button color="primary"  [disabled]="formHasAtLeastOneEntry(FORM_CLIENT_ENTITY) || isFormDisabled()"
                          (click)="addLegalEntityToForm(FORM_CLIENT_ENTITY, Level.EXTENDED)">Add Client Entity Information</button>
                      </div>

                      <table class="mt-4 mat-elevation-z4" width="100%">
                        <thead>
                          <th class="form-table-header">Entity Information</th>
                          <th class="form-table-header">Source of Funds</th>
                          <th class="form-table-header">Nature of Business</th>
                          <th class="form-table-header center">Actions</th>
                        </thead>
                        <tbody [formArrayName]="FORM_CLIENT_ENTITY">
                          <tr *ngFor="let p of getFormArray(FORM_CLIENT_ENTITY).controls; let i = index" [formGroupName]="i" >
                            <td>
                              <kyc-entity (click)="editItem_LegalEntity(p.value.id)" [legalEntity]="getLegalEntityFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-entity>
                            </td>
                            <td>
                              <mat-form-field style="width: 120px;">
                                <input matInput type="text" formControlName="businessSourceofFund" required [readonly]="isFormDisabled()" />
                              </mat-form-field>
                            </td>
                            <td>
                              <mat-form-field style="width: 120px;">
                                <input matInput type="text" formControlName="natureoftheBusiness" required [readonly]="isFormDisabled()" />
                              </mat-form-field>
                            </td>
                            <td class="text-center">
                              <button type="button" mat-icon-button [disabled]="isFormDisabled()" (click)="editItem_LegalEntity(p.value.id)">
                                <mat-icon>edit</mat-icon>
                              </button>
                              <button type="button" mat-icon-button color="warn" [disabled]="isFormDisabled()" (click)="removeItem(FORM_CLIENT_ENTITY, i)">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </td>
                          </tr>
                          <tr *ngIf="isFormCollectionEmpty(FORM_CLIENT_ENTITY)">
                            <td colspan="5">No data in this table.</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
  
                    <!-- DIRECTORS  -->
                    <div *ngSwitchCase="SectionType.DIRECTORS">
                      <div class="col-12">
                        <button type="button" mat-raised-button color="primary" [disabled]="isFormDisabled()"
                          (click)="addPersonToForm(FORM_DIRECTORS, Level.BASIC)">Add Directors</button>
                      </div>

                      <table class="mt-4 mat-elevation-z4" width="100%">
                        <thead>
                          <th class="form-table-header">Directors</th>
                          <th class="form-table-header center">Actions</th>
                        </thead>
                        <tbody [formArrayName]="FORM_DIRECTORS">
                          <tr *ngFor="let p of getFormArray(FORM_DIRECTORS).controls; let i = index" [formGroupName]="i" >
                            <td>
                              <kyc-person (click)="editItem_Person(p.value.id)" [person]="getPersonFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-person>
                            </td>
                            <td class="text-center">
                              <button type="button" mat-icon-button [disabled]="isFormDisabled()" (click)="editItem_Person(p.value.id)">
                                <mat-icon>edit</mat-icon>
                              </button>
                              <button type="button" mat-icon-button color="warn" [disabled]="isFormDisabled()" (click)="removeItem(FORM_DIRECTORS, i)" [disabled]="isFormDisabled()">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </td>
                          </tr>
                          <tr *ngIf="isFormCollectionEmpty(FORM_DIRECTORS)">
                            <td colspan="5">No data in this table.</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- REGULATORY_QUESTIONS_1  -->
                    <div *ngSwitchCase="SectionType.REGULATORY_QUESTIONS_1">
                      <!-- show the 10% regulatory chart -->
                      <!-- QUESTION HIDDEN START -->
                      <div class="pt-2" *ngIf="(getQuestionByAttribute(FORM_QUESTION_REG)?.questionAnswer == 'true')">

                        <!--                row start-->
                        <button mat-raised-button type="button" color="primary"
                                (click)="addOwnerOfVotingRights()"
                                [disabled]="isFormDisabled()">
                          Add Owner of Voting Rights
                        </button>

                        <!-- table start-->
                        <table class="mt-4 mat-elevation-z4" width="100%">
                          <thead>
                            <th class="form-table-header">Owner of Voting Right</th>
                            <th class="form-table-header">Publicly Traded Company</th>
                            <th class="form-table-header">Percentage (%) Owned</th>
                            <th class="form-table-header center">Actions</th>
                          </thead>
                          <tbody>
                          <tr *ngFor="let p of getFormArray(FORM_REG_PEOPLE).controls; let i = index;">
                            <td>{{p.value.ownerOfVotingRights}}</td>
                            <td>{{p.value.publiclyTradedCompany}}</td>
                            <td>{{p.value.percentageOwnership}}</td>
                            <td class="text-center">
                              <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                                      (click)="removeItem(FORM_REG_PEOPLE, i)">
                                <mat-icon title="Remove">delete</mat-icon>
                              </button>
                            </td>
                          </tr>
                          <tr *ngIf="isFormCollectionEmpty(FORM_REG_PEOPLE)">
                            <td colspan="5">No data in this table.</td>
                          </tr>
                          </tbody>
                        </table>

                      </div>
                      <!-- QUESTION HIDDEN END -->

                    </div>

                     <!-- REGULATORY_QUESTIONS_2  -->
                     <div *ngSwitchCase="SectionType.REGULATORY_QUESTIONS_2">
                      <!-- show the 10% regulatory chart -->
                      <!-- QUESTION HIDDEN START -->
                      <div class="pt-2" *ngIf="(getQuestionByAttribute(FORM_QUESTION_REG_2)?.questionAnswer == 'true')">

                        <!--                row start-->
                        <button mat-raised-button type="button" color="primary"
                                (click)="addAuthorizeSignatory()"
                                [disabled]="isFormDisabled()">
                          Add Authorized Signatory Name
                        </button>

                        <!-- table start-->
                        <table class="mt-4 mat-elevation-z4" width="100%">
                          <thead>
                            <th class="form-table-header">Authorized Signatory</th>
                            <th class="form-table-header">Company Name</th>
                            <th class="form-table-header">Percentage (%) Owned</th>
                            <th class="form-table-header center">Actions</th>
                          </thead>
                          <tbody>
                          <tr *ngFor="let p of getFormArray(FORM_REG_ENT).controls; let i = index;">
                            <td>{{p.value.authorizedSignatory}}</td>
                            <td>{{p.value.companyName}}</td>
                            <td>{{p.value.percentageOwnership}}</td>
                            <td class="text-center">
                              <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                                      (click)="removeItem(FORM_REG_ENT, i)">
                                <mat-icon title="Remove">delete</mat-icon>
                              </button>
                            </td>
                          </tr>
                          <tr *ngIf="isFormCollectionEmpty(FORM_REG_ENT)">
                            <td colspan="5">No data in this table.</td>
                          </tr>
                          </tbody>
                        </table>

                      </div>
                      <!-- QUESTION HIDDEN END -->

                    </div>

                    <!-- CONTROL_PERSON  -->
                    <div *ngSwitchCase="SectionType.CONTROL_PERSON">
                    <button mat-raised-button type="button" color="primary"
                            (click)="addPersonToForm(FORM_CONTROL_PEOPLE, Level.FULL)"
                            [disabled]="isFormDisabled()">
                      Add Control Person
                    </button>

                    <!-- table start-->
                    <table class="mt-4 mat-elevation-z4" width="100%">
                      <thead>
                        <th class="form-table-header">Control Person (Natural Person)</th>
                        <th class="form-table-header center">Actions</th>
                      </thead>
                      <tbody>
                      <tr *ngFor="let p of getFormArray(FORM_CONTROL_PEOPLE).controls; let i = index;">
                        <td>
                          <kyc-person (click)="editItem_Person(p.value.id)" [person]="getPersonFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-person>
                        </td>
                        <td class="text-center">
                          <button mat-icon-button type="button" [disabled]="isFormDisabled()"
                            (click)="editItem_Person(p.value.id)">
                            <mat-icon title="Edit">edit</mat-icon>
                          </button>
                          <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                            (click)="removeItem(FORM_CONTROL_PEOPLE, i)">
                          <mat-icon title="Remove">delete</mat-icon>
                        </button>

                        </td>
                      </tr>
                      <tr *ngIf="isFormCollectionEmpty(FORM_CONTROL_PEOPLE)">
                        <td colspan="5">No data in this table.</td>
                      </tr>
                      </tbody>
                    </table>
                    </div>

                    <!-- DIRECT_BENEFICIAL_OWNERS  -->
                    <div *ngSwitchCase="SectionType.DIRECT_BENEFICIAL_OWNERS">
                      <div *ngIf="(getQuestionByAttribute(FORM_QUESTION_DBO)?.questionAnswer == 'true')">
                        <button mat-raised-button type="button" color="primary"
                          (click)="addPersonToForm(FORM_DBO_PEOPLE, Level.EXTENDED)"
                          [disabled]="isFormDisabled()">
                          Add Person
                        </button>
                        &nbsp;
                        <button mat-raised-button type="button" color="primary"
                          (click)="addLegalEntityToForm(FORM_DBO_ENTITIES, Level.EXTENDED)"
                          [disabled]="isFormDisabled()">
                          Add Legal Entity
                        </button>

                        <!-- table start-->
                        <table class="mt-2 mat-elevation-z4" width="100%">
                          <thead>
                            <th class="form-table-header">Direct Beneficial Owner</th>
                            <th class="form-table-header">Type</th>
                            <th class="form-table-header">Percentage Ownership</th>
                            <th class="form-table-header center">Actions</th>
                          </thead>
                          <tbody  [formArrayName]="FORM_DBO_PEOPLE">
                            <tr *ngFor="let p of getFormArray(FORM_DBO_PEOPLE).controls; let i = index;" [formGroupName]="i">
                              <td>
                                <kyc-person (click)="editItem_Person(p.value.id)" [person]="getPersonFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-person>
                              </td>
                              <td>Natural Person</td>
                              <td>
                                <mat-form-field>
                                  <input matInput type="number" formControlName="percentageOwnership" required [readonly]="isFormDisabled()" >
                                </mat-form-field>
                              </td>
                              <!-- <td>{{cp.value.percentageOwnership}}</td> -->
                              <td class="text-center">
                                <button mat-icon-button type="button" [disabled]="isFormDisabled()"
                                  (click)="editItem_Person(p.value.id)">
                                  <mat-icon title="Edit">edit</mat-icon>
                                </button>
                                <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                                  (click)="removeItem(FORM_DBO_PEOPLE, i)">
                                  <mat-icon title="Remove">delete</mat-icon>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                          <tbody [formArrayName]="FORM_DBO_ENTITIES">
                          <tr *ngFor="let p of getFormArray(FORM_DBO_ENTITIES).controls; let i = index;" [formGroupName]="i">
                            <td>
                              <kyc-entity (click)="editItem_LegalEntity(p.value.id)" [legalEntity]="getLegalEntityFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-entity>
                            </td>
                            <td>Legal Entity</td>
                            <td>
                              <mat-form-field>
                                <input matInput type="number" formControlName="percentageOwnership" required [readonly]="isFormDisabled()">
                              </mat-form-field>
                            </td>
                            <td class="text-center">
                              <button mat-icon-button type="button" [disabled]="isFormDisabled()"
                                (click)="editItem_LegalEntity(p.value.id)">
                                <mat-icon title="Edit">edit</mat-icon>
                              </button>
                              <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                                (click)="removeItem(FORM_DBO_ENTITIES, i)">
                                <mat-icon title="Remove">delete</mat-icon>
                              </button>
                            </td>
                          </tr>

                          <tr *ngIf="isFormCollectionEmpty(FORM_DBO_PEOPLE) && isFormCollectionEmpty(FORM_DBO_ENTITIES)">
                            <td colspan="5">No data in this table.</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
  
                    <!-- INDIRECT_BENEFICIAL_OWNERS  -->
                    <div *ngSwitchCase="SectionType.INDIRECT_BENEFICIAL_OWNERS">
                      <div *ngIf="(getQuestionByAttribute(FORM_QUESTION_IDBO)?.questionAnswer == 'true')">
                        <button mat-raised-button type="button" color="primary"
                          (click)="addPersonToForm(FORM_IDBO_PEOPLE, Level.FULL)"
                          [disabled]="isFormDisabled()">
                          Add Person
                        </button>
                        &nbsp;
                        <button mat-raised-button type="button" color="primary"
                          (click)="addLegalEntityToForm(FORM_IDBO_ENTITIES, Level.FULL)"
                          [disabled]="isFormDisabled()">
                          Add Legal Entity
                        </button>

                        <!-- table start-->
                        <table class="mt-2 mat-elevation-z4" width="100%">
                          <thead>
                            <th class="form-table-header">Indirect Beneficial Owner</th>
                            <th class="form-table-header">Type</th>
                            <th class="form-table-header">Percentage Ownership</th>
                            <th class="form-table-header center">Actions</th>
                          </thead>
                          <tbody [formArrayName]="FORM_IDBO_PEOPLE">
                          <tr *ngFor="let p of getFormArray(FORM_IDBO_PEOPLE).controls; let i = index;" [formGroupName]="i">
                            <td>
                              <kyc-person (click)="editItem_Person(p.value.id)" [person]="getPersonFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-person>
                            </td>
                            <td>Natural Person</td>
                            <td>
                              <mat-form-field>
                                <input matInput type="number" formControlName="percentageOwnership" required [readonly]="isFormDisabled()">
                              </mat-form-field>
                            </td>
                            <td class="text-center">
                              <button mat-icon-button type="button" [disabled]="isFormDisabled()"
                                (click)="editItem_Person(p.value.id)">
                                <mat-icon title="Edit">edit</mat-icon>
                              </button>
                              <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                                (click)="removeItem(FORM_IDBO_PEOPLE, i)">
                                <mat-icon title="Remove">delete</mat-icon>
                              </button>
                            </td>
                          </tr>
                          </tbody>
                          <tbody [formArrayName]="FORM_IDBO_ENTITIES">
                          <tr *ngFor="let p of getFormArray(FORM_IDBO_ENTITIES).controls; let i = index;" [formGroupName]="i">
                            <td>
                              <kyc-entity (click)="editItem_LegalEntity(p.value.id)" [legalEntity]="getLegalEntityFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-entity>
                            </td>
                            <td>Legal Entity</td>
                            <td>
                              <mat-form-field>
                                <input matInput type="number" formControlName="percentageOwnership" required [readonly]="isFormDisabled()">
                              </mat-form-field>
                            </td>
                            <td class="text-center">
                              <button mat-icon-button type="button" [disabled]="isFormDisabled()"
                                (click)="editItem_LegalEntity(p.value.id)">
                                <mat-icon title="Edit">edit</mat-icon>
                              </button>
                              <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                                (click)="removeItem(FORM_IDBO_ENTITIES, i)">
                                <mat-icon title="Remove">delete</mat-icon>
                              </button>
                            </td>
                          </tr>

                          <tr *ngIf="isFormCollectionEmpty(FORM_IDBO_PEOPLE) && isFormCollectionEmpty(FORM_IDBO_ENTITIES)">
                            <td colspan="5">No data in this table.</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
  
                    <!-- GOVERNING_BODY  -->
                    <div *ngSwitchCase="SectionType.GOVERNING_BODY">
                      <button mat-raised-button type="button" color="primary"
                        (click)="addPersonToForm(FORM_GB_PEOPLE, Level.BASIC)"
                        [disabled]="isFormDisabled()">
                        Add Person
                      </button>
                      &nbsp;
                      <button mat-raised-button type="button" color="primary"
                        (click)="addLegalEntityToForm(FORM_GB_ENTITIES, Level.BASIC)"
                        [disabled]="isFormDisabled()">
                        Add Legal Entity
                      </button>

                      <!-- table start-->
                      <table class="mt-2 mat-elevation-z4" width="100%">
                        <thead>
                          <th class="form-table-header">Governing Body Members</th>
                          <th class="form-table-header">Type</th>
                          <th class="form-table-header center">Actions</th>
                        </thead>
                        <tbody>
                        <tr *ngFor="let p of getFormArray(FORM_GB_PEOPLE).controls; let i = index;">
                          <td>
                            <kyc-person (click)="editItem_Person(p.value.id)" [person]="getPersonFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-person>
                          </td>
                          <td>Natural Person</td>
                          <td class="text-center">
                            <button mat-icon-button type="button" [disabled]="isFormDisabled()"
                              (click)="editItem_Person(p.value.id)">
                              <mat-icon title="Edit">edit</mat-icon>
                            </button>
                            <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                              (click)="removeItem(FORM_GB_PEOPLE, i)">
                              <mat-icon title="Remove">delete</mat-icon>
                            </button>
                          </td>
                        </tr>

                        <tr *ngFor="let p of getFormArray(FORM_GB_ENTITIES).controls; let i = index;">
                          <td>
                            <kyc-entity (click)="editItem_LegalEntity(p.value.id)" [legalEntity]="getLegalEntityFromCache(p.value.id)"></kyc-entity>
                          </td>
                          <td>Legal Entity</td>
                          <td class="text-center">
                            <button mat-icon-button type="button" [disabled]="isFormDisabled()"
                              (click)="editItem_LegalEntity(p.value.id)">
                              <mat-icon title="Edit">edit</mat-icon>
                            </button>
                            <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                              (click)="removeItem(FORM_GB_ENTITIES, i)">
                              <mat-icon title="Remove">delete</mat-icon>
                            </button>
                          </td>
                        </tr>

                        <tr *ngIf="isFormCollectionEmpty(FORM_GB_PEOPLE) && isFormCollectionEmpty(FORM_GB_ENTITIES)">
                          <td colspan="5">No data in this table.</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- TRUSTEES  -->
                    <div *ngSwitchCase="SectionType.TRUSTEES">
                      <button mat-raised-button type="button" color="primary"
                        (click)="addPersonToForm(FORM_TRUST_PEOPLE, Level.FULL)"
                        [disabled]="isFormDisabled()">
                        Add Person
                      </button>
                      &nbsp;
                      <button mat-raised-button type="button" color="primary"
                        (click)="addLegalEntityToForm(FORM_TRUST_ENTITIES, Level.FULL)"
                        [disabled]="isFormDisabled()">
                        Add Legal Entity
                      </button>

                      <!-- table start-->
                      <table class="mt-2 mat-elevation-z4" width="100%">
                        <thead>
                          <th class="form-table-header">Truestees</th>
                          <th class="form-table-header">Type</th>
                          <th class="form-table-header center">Actions</th>
                        </thead>
                        <tbody>
                        <tr *ngFor="let p of getFormArray(FORM_TRUST_PEOPLE).controls; let i = index;">
                          <td>
                            <kyc-person (click)="editItem_Person(p.value.id)" [person]="getPersonFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-person>
                          </td>
                          <td>Natural Person</td>
                          <td class="text-center">
                            <button mat-icon-button type="button" [disabled]="isFormDisabled()"
                              (click)="editItem_Person(p.value.id)">
                              <mat-icon title="Edit">edit</mat-icon>
                            </button>
                            <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                              (click)="removeItem(FORM_TRUST_PEOPLE, i)">
                              <mat-icon title="Remove">delete</mat-icon>
                            </button>
                          </td>
                        </tr>

                        <tr *ngFor="let p of getFormArray(FORM_TRUST_ENTITIES).controls; let i = index;">
                          <td>
                            <kyc-entity (click)="editItem_LegalEntity(p.value.id)" [legalEntity]="getLegalEntityFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-entity>
                          </td>
                          <td>Legal Entity</td>
                          <td class="text-center">
                            <button mat-icon-button type="button" [disabled]="isFormDisabled()"
                              (click)="editItem_LegalEntity(p.value.id)">
                              <mat-icon title="Edit">edit</mat-icon>
                            </button>
                            <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                              (click)="removeItem(FORM_TRUST_ENTITIES, i)">
                              <mat-icon title="Remove">delete</mat-icon>
                            </button>
                          </td>
                        </tr>

                        <tr *ngIf="isFormCollectionEmpty(FORM_TRUST_PEOPLE) && isFormCollectionEmpty(FORM_TRUST_ENTITIES)">
                          <td colspan="5">No data in this table.</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- TRUST_SETTLORS  -->
                    <div *ngSwitchCase="SectionType.TRUST_SETTLORS">
                      <button mat-raised-button type="button" color="primary"
                        (click)="addPersonToForm(FORM_TRUST_SET_PEOPLE, Level.LONG)"
                        [disabled]="isFormDisabled()">
                        Add Person
                      </button>
                      &nbsp;
                      <button mat-raised-button type="button" color="primary"
                        (click)="addLegalEntityToForm(FORM_TRUST_SET_ENTITIES, Level.LONG)"
                        [disabled]="isFormDisabled()">
                        Add Legal Entity
                      </button>

                      <!-- table start-->
                      <table class="mt-2 mat-elevation-z4" width="100%">
                        <thead>
                          <th class="form-table-header">Truestees</th>
                          <th class="form-table-header">Type</th>
                          <th class="form-table-header center">Actions</th>
                        </thead>
                        <tbody>
                        <tr *ngFor="let p of getFormArray(FORM_TRUST_SET_PEOPLE).controls; let i = index;">
                          <td>
                            <kyc-person (click)="editItem_Person(p.value.id)" [person]="getPersonFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-person>
                          </td>
                          <td>Natural Person</td>
                          <td class="text-center">
                            <button mat-icon-button type="button" [disabled]="isFormDisabled()"
                              (click)="editItem_Person(p.value.id)">
                              <mat-icon title="Edit">edit</mat-icon>
                            </button>
                            <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                              (click)="removeItem(FORM_TRUST_SET_PEOPLE, i)">
                              <mat-icon title="Remove">delete</mat-icon>
                            </button>
                          </td>
                        </tr>

                        <tr *ngFor="let p of getFormArray(FORM_TRUST_SET_ENTITIES).controls; let i = index;">
                          <td>
                            <kyc-entity (click)="editItem_LegalEntity(p.value.id)" [legalEntity]="getLegalEntityFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-entity>
                          </td>
                          <td>Legal Entity</td>
                          <td class="text-center">
                            <button mat-icon-button type="button" [disabled]="isFormDisabled()"
                              (click)="editItem_LegalEntity(p.value.id)">
                              <mat-icon title="Edit">edit</mat-icon>
                            </button>
                            <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                              (click)="removeItem(FORM_TRUST_SET_ENTITIES, i)">
                              <mat-icon title="Remove">delete</mat-icon>
                            </button>
                          </td>
                        </tr>

                        <tr *ngIf="isFormCollectionEmpty(FORM_TRUST_SET_PEOPLE) && isFormCollectionEmpty(FORM_TRUST_SET_ENTITIES)">
                          <td colspan="5">No data in this table.</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- TRUST_BENEFICIARIES  -->
                    <div *ngSwitchCase="SectionType.TRUST_BENEFICIARIES">
                      <button mat-raised-button type="button" color="primary"
                        (click)="addPersonToForm(FORM_TRUST_BEN_PEOPLE, Level.FULL)"
                        [disabled]="isFormDisabled()">
                        Add Person
                      </button>
                      &nbsp;
                      <button mat-raised-button type="button" color="primary"
                        (click)="addLegalEntityToForm(FORM_TRUST_BEN_ENTITIES, Level.LONG)"
                        [disabled]="isFormDisabled()">
                        Add Legal Entity
                      </button>

                      <!-- table start-->
                      <table class="mt-2 mat-elevation-z4" width="100%">
                        <thead>
                          <th class="form-table-header">Truestees</th>
                          <th class="form-table-header">Type</th>
                          <th class="form-table-header center">Actions</th>
                        </thead>
                        <tbody>
                        <tr *ngFor="let p of getFormArray(FORM_TRUST_BEN_PEOPLE).controls; let i = index;">
                          <td>
                            <kyc-person (click)="editItem_Person(p.value.id)" [person]="getPersonFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-person>
                          </td>
                          <td>Natural Person</td>
                          <td class="text-center">
                            <button mat-icon-button type="button" [disabled]="isFormDisabled()"
                              (click)="editItem_Person(p.value.id)">
                              <mat-icon title="Edit">edit</mat-icon>
                            </button>
                            <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                              (click)="removeItem(FORM_TRUST_BEN_PEOPLE, i)">
                              <mat-icon title="Remove">delete</mat-icon>
                            </button>
                          </td>
                        </tr>

                        <tr *ngFor="let p of getFormArray(FORM_TRUST_BEN_ENTITIES).controls; let i = index;">
                          <td>
                            <kyc-entity (click)="editItem_LegalEntity(p.value.id)" [legalEntity]="getLegalEntityFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-entity>
                          </td>
                          <td>Legal Entity</td>
                          <td class="text-center">
                            <button mat-icon-button type="button" [disabled]="isFormDisabled()"
                              (click)="editItem_LegalEntity(p.value.id)">
                              <mat-icon title="Edit">edit</mat-icon>
                            </button>
                            <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                              (click)="removeItem(FORM_TRUST_BEN_ENTITIES, i)">
                              <mat-icon title="Remove">delete</mat-icon>
                            </button>
                          </td>
                        </tr>

                        <tr *ngIf="isFormCollectionEmpty(FORM_TRUST_BEN_PEOPLE) && isFormCollectionEmpty(FORM_TRUST_BEN_ENTITIES)">
                          <td colspan="5">No data in this table.</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- AUTHORIZED_SIGNATORIES  -->
                    <div *ngSwitchCase="SectionType.AUTHORIZED_SIGNATORIES">
                      <button mat-raised-button type="button" color="primary"
                              (click)="addPersonToForm(FORM_AUTH_PEOPLE, Level.EXTENDED)"
                              [disabled]="isFormDisabled()">
                        Add Authorized Signatory
                      </button>
  
                      <!-- table start-->
                      <table class="mt-2 mat-elevation-z4" width="100%">
                        <thead>
                          <th class="form-table-header">Authorized Signaties</th>
                          <th class="form-table-header center">Actions</th>
                        </thead>
                        <tbody>
                        <tr *ngFor="let p of getFormArray(FORM_AUTH_PEOPLE).controls; let i = index;">
                          <td>
                            <kyc-person (click)="editItem_Person(p.value.id)" [person]="getPersonFromCache(p.value.id)" [section]="section.kycSectionType"></kyc-person>
                          </td>
                          <td class="text-center">
                            <button mat-icon-button type="button" [disabled]="isFormDisabled()"
                              (click)="editItem_Person(p.value.id)">
                              <mat-icon title="Edit">edit</mat-icon>
                            </button>
                            <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                              (click)="removeItem(FORM_AUTH_PEOPLE, i)">
                              <mat-icon title="Remove">delete</mat-icon>
                            </button>
                          </td>
                        </tr>
                        <tr *ngIf="isFormCollectionEmpty(FORM_AUTH_PEOPLE)">
                          <td colspan="5">No data in this table.</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    
                    <!-- PRIMARY_CONTACT  -->
                    <div *ngSwitchCase="SectionType.PRIMARY_CONTACT">
                      <button mat-raised-button type="button" color="primary"
                              (click)="addPrimaryContactPerson()"
                              [disabled]="isFormDisabled() || formHasAtLeastOneEntry(FORM_PRIMARY_CONTACTS)">
                        Add Primary Contact Person
                      </button>
  
                      <!-- table start-->
                      <table class="mt-2 mat-elevation-z4" width="100%">
                        <thead>
                          <th class="form-table-header">Contact Person</th>
                          <th class="form-table-header">Email</th>
                          <th class="form-table-header center">Actions</th>
                        </thead>
                        <tbody>
                        <tr *ngFor="let p of getFormArray(FORM_PRIMARY_CONTACTS).controls; let i = index;">
                          <td>{{p.value.firstName}} {{p.value.lastName}}</td>
                          <td>{{p.value.email}}</td>
                          <td class="text-center">
                            <button mat-icon-button type="button" color="warn" [disabled]="isFormDisabled()"
                              (click)="removeItem(FORM_PRIMARY_CONTACTS, i)">
                              <mat-icon title="Remove">delete</mat-icon>
                            </button>
                          </td>
                        </tr>
                        <tr *ngIf="isFormCollectionEmpty(FORM_PRIMARY_CONTACTS)">
                          <td colspan="5">No data in this table.</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
  
                    <!-- CERTIFICATION  -->
                    <div *ngSwitchCase="SectionType.CERTIFICATION">
                      <div class="section-questions" style="display: flex; flex-direction: column;" 
                        *ngIf="section.kycSectionHeader.kycQuestions.length > 0" [formArrayName]="FORM_QUESTIONS">
                        <div *ngFor="let question of getFormArray(FORM_QUESTIONS).controls; let i = index" [formGroupName]="i" style="display: block; margin: 0; padding: 0; ">
                          <div *ngIf="questionContainerInSection(section.kycSectionHeader.kycQuestions, question.value.questionAnswerAttribute)">
                            <!-- text  -->
                            <div class="col-12" *ngIf="question.value.questionType == 'TEXT'"
                              style="display: flex; flex-direction: column; gap: 5px;">
                              <div class="col-12">{{question.value.questionText}}</div>
                              <div class="col-6">
                                <mat-form-field class="form-field">
                                  <input type="text" matInput formControlName="questionAnswer" [readonly]="isFormDisabled()" />
                                </mat-form-field>
                              </div>
                            </div>
                            </div>
                        </div>
                      </div>
  
                    </div>

                  </div>
                  <div class="section-footer">
                    {{section.kycSectionFooter.footerTexts}}
                  </div>
                  <div class="section-actions">
                    <button mat-raised-button [disabled]="i == 0" (click)="prevSection(i)">Previous Section</button>
                    <button mat-raised-button color="primary" (click)="nextSection(i, false)" [disabled]="i >= selectedEntityKyc.kycSections.length-1" *ngIf="isFormDisabled()">View Next Section</button>
                    <button mat-raised-button color="primary" (click)="nextSection(i, true)" *ngIf="isFormDisabled() == false">Validate Information {{ i >= selectedEntityKyc.kycSections.length-1 ? '' : 'and Go to Next Section' }}</button>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>

          <!-- SAVE BUTTON -->
          <div class="row pt-4 pb-5">
            <div class="col-12 text-end">
              <button type="button" mat-raised-button
                [hasPermission]="util.Permission.CAN_SUBMIT_KYC"
                [disabledOption1]="{ condition: isFormDisabled(), message: 'Form is Disabled' }"
                [disabledOption2]="{ condition: canSubmit() == false, message: 'Cannot yet submit KYC' }"
                color="accent" (click)="submitKyc()">
                Submit KYC for Rondeivu Review
              </button>&nbsp;
              <button type="submit" mat-raised-button color="primary" (click)="saveKyc()" 
                [disabled]="isFormDisabled()"
              >Save KYC Draft</button>
            </div>
          </div>
        </form>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>



